module.exports = __webpack_public_path__ + "img/img-no.9f90d41b.png";